<div
    class="modal-header modal-header-lg relative"
    [ngClass]="{
        block: mode === 'BLOCK',
        advise: mode === 'ADVISE',
        pass: mode === 'PASS'
    }"
>
    <div
        class="information-icon"
        [ngClass]="{
            'block-icon': mode === 'BLOCK',
            'advise-icon': mode === 'ADVISE',
            'pass-icon': mode === 'PASS'
        }"
    >
        <span *ngIf="mode === 'ADVISE'" class="fa fa-exclamation"></span>
        <span *ngIf="mode === 'BLOCK'" class="fad fa-times"></span>
        <span *ngIf="mode === 'PASS'" class="fad fa-check"></span>
    </div>
    <h4
        class="modal-title modal-title-sm"
        [ngClass]="{
            block: mode === 'BLOCK',
            advise: mode === 'ADVISE',
            pass: mode === 'PASS'
        }"
    >
        {{ modalTitle }}
    </h4>
</div>
<div class="modal-body information-modal">
    <div class="horizontal-container">
        <div
            *ngIf="ruleOutcome?.message?.length"
            class="vertical-container container-scroll fill"
        >
            <div class="container-scroll airspace-message">
                <p [innerHTML]="ruleOutcome.message | autolink"></p>
            </div>
        </div>
        <div
            *ngIf="ruleOutcome.message == null || !ruleOutcome.message.length"
            class="vertical-container container-scroll fill"
        >
            <span class="fa fa-sparkles sparkle"></span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn"
        [ngClass]="{
            block: mode === 'BLOCK',
            advise: mode === 'ADVISE',
            pass: mode === 'PASS'
        }"
        (click)="close()"
    >
        OK
    </button>
</div>
